import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlansPriceService, PlansPrice } from '../../../services/plans-price.service';

export interface InactivePlanPricesModalData {
  planId: number;
  planName: string;
}

@Component({
  selector: 'app-inactive-plan-prices-modal',
  template: `
    <h1 mat-dialog-title>Preços do Plano: {{ data.planName }}</h1>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
      <div class="table-container" *ngIf="prices && prices.length > 0; else noData">
        <table class="prices-table">
          <thead>
            <tr>
              <th>Valor</th>
              <th>Criada em</th>
              <th>Ativar em</th>
              <th>Inativa em</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let price of prices" [ngClass]="{'inactive-price': !price.status}">
              <td>{{ price.price | currency }}</td>
              <td>{{ price.createdAt | dateBRPlanPrice }}</td>
              <td>{{ price.startDate | dateBRPlanPrice }}</td>
              <td>{{ price.inactivatedAt ? (price.inactivatedAt | dateBRPlanPrice) : '-' }}</td>
              <td>{{ price.status ? 'Ativo' : 'Inativo' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noData>
        <p>Não há preços cadastrados para este plano.</p>
      </ng-template>
    </div>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="close()">Fechar</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .table-container {
      margin-top: 15px;
    }
    .prices-table {
      width: 100%;
      border-collapse: collapse;
    }
    .prices-table th, .prices-table td {
      border: 1px solid #ddd;
      padding: 8px;
    }
    .prices-table th {
      background-color: #f2f2f2;
      text-align: left;
    }
    .inactive-price {
      opacity: 0.6;
      color: #777;
    }
  `]
})
export class InactivePlanPricesModalComponent implements OnInit {
  prices: PlansPrice[] = [];

  constructor(
    private dialogRef: MatDialogRef<InactivePlanPricesModalComponent>,
    private plansPriceService: PlansPriceService,
    @Inject(MAT_DIALOG_DATA) public data: InactivePlanPricesModalData
  ) {}

  ngOnInit(): void {
    this.loadPrices();
  }

  loadPrices(): void {
    this.plansPriceService.getPrices(this.data.planId, 1, '')
      .subscribe((response: any) => {
        this.prices = response.data;
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
